import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  isSidebarPinned = false;
  isSidebarToggled = false;
  sidebarWidth = 280; // Default width in pixels

  constructor() { }

  toggleSidebar() {
    this.isSidebarToggled = !this.isSidebarToggled;
  }

  toggleSidebarPin() {
    this.isSidebarPinned = !this.isSidebarPinned;
  }

  setSidebarWidth(width: number) {
    this.sidebarWidth = Math.max(200, Math.min(400, width)); // Min 200px, Max 400px
  }

  getSidebarStat() {
    return {
      isSidebarPinned: this.isSidebarPinned,
      isSidebarToggled: this.isSidebarToggled,
      sidebarWidth: this.sidebarWidth
    }
  }

}
